import React from 'react';
import {
  motion,
  useScroll,
  useSpring,
  useTransform,
  useVelocity,
  useAnimationFrame, AnimatePresence,
  useMotionValue
} from "framer-motion";
import { wrap } from "@motionone/utils";
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import { useState } from 'react';
import { useAuth } from './AuthContext';
import CreativeLoader from './CreativeLoader';
function MarqueeItem({ children, baseVelocity = -3 }) {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400
  });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false
  });

  // This creates the "infinite" loop logic
  const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);

  const directionFactor = useRef(1);
  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

    // If scrolling, add the scroll speed to the movement
    if (velocityFactor.get() < 0) {
      directionFactor.current = -1;
    } else if (velocityFactor.get() > 0) {
      directionFactor.current = -1;
    }

    moveBy += directionFactor.current * moveBy * velocityFactor.get();

    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="marquee-wrapper">
      <motion.div className="scroller" style={{ x }}>
        <span className="marquee-text">{children} </span>
        <span className="marquee-text">{children} </span>
        <span className="marquee-text">{children} </span>
        <span className="marquee-text">{children} </span>
      </motion.div>
    </div>
  );
}
export default function LandingPage() {
  const memes = [
    { id: 1, url: 'https://media.tenor.com/qdmcn9OFhDsAAAA1/vigilanteskass.webp' },
    { id: 2, url: 'https://i.pinimg.com/originals/9a/b2/76/9ab27659c7cce9ab044cff316a862cec.gif', text: 'WRITING CODE AT 3AM' },
    { id: 3, url: 'https://media.tenor.com/RLT9ddLk5jUAAAAj/6-6-7.gif', text: 'EVERYTHING IS FINE' },
    { id: 4, url: 'https://i.kym-cdn.com/photos/images/newsfeed/003/136/289/782.jpg', text: 'TELL ME MORE ABOUT 2026' },
    { id: 5, url: 'https://media1.tenor.com/m/_lsN-V6fMEsAAAAC/unnala-unnala-unnala.gif', text: 'WHEN THE BUILD PASSES' },
    { id: 6, url: 'https://media.tenor.com/0XVlanv5oNcAAAAM/italian-brainrot-noo-polizia.gif'},
    { id: 7, url: 'https://media.tenor.com/padjXTYSW5AAAAAM/chimpanzee.gif',text: 'TELL ME MORE ABOUT 2026'},
    { id: 8, url: 'https://media.tenor.com/yElPsrGJ1fYAAAA1/dexter-doakes.webp'},
    { id: 9, url: 'https://media.tenor.com/GDZi3PYkMf4AAAAM/suspicious.gif'},
    { id: 10, url: 'https://media.tenor.com/dXkynmDe8ZMAAAAM/shaquille-o%27neal-shaq.gif'},
    { id: 11, url: 'https://media.tenor.com/uPvYZKQ8oNgAAAAM/job-application.gif'},
    { id: 12, url: 'https://media.tenor.com/a-zuRHjs4zsAAAA1/2026-meme-2026-memes.webp'},
    { id: 13, url: 'https://media.tenor.com/SWyN3IGHY44AAAAm/poor-homeless.webp'},
    { id: 14, url: 'https://media.tenor.com/JjzYk--eE5QAAAAm/emoji-de-echo.webp'},
    { id: 15, url: 'https://media.tenor.com/9LyTwl1lp4MAAAAM/meme-sybau.gif'},
    { id: 16, url: 'https://media.tenor.com/rEfrBa_MS_0AAAAM/rajini-meme.gif'},
    { id: 17, url: 'https://preview.redd.it/how-did-this-joint-jagadeesan-thing-start-v0-6ihl0ptkrknf1.png?width=1080&format=png&auto=webp&s=2a97e9c509c3564ee253ed7f6886f9bb7cbb1106'},
    { id: 18, url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQh0AWYmgNZW3KfkfTkWGKE_FREmUEoqbVpLju9Bp3bmCJ1LO5Z'},
    { id: 19, url: 'https://media.tenor.com/A56c3oSV2WUAAAA1/ts-pmo.webp'},
    { id: 20, url: 'https://media.tenor.com/jZQ_zoIFZfYAAAAM/gi-hun-squid-game.gif'}, 
    { id: 21, url: 'https://media.tenor.com/yWUpg5fEOtcAAAAm/get-out-get-outta-here.webp'}
  ];
  const QUIZ_DATA = [
    { question: "WHAT HAPPENS TO YOUR AURA IF YOU TRIP IN PUBLIC?", options: ["+1000 AURA", "-5000 AURA", "STAYS INFINITE", "AURA IS TRANSFERRED"], correct: 1, msg: "AURA DEBT IS REAL." },
    { question: "IF SOMEONE IS 'CASUALLY CRASHOUT', THEY ARE...", options: ["SLEEPING", "LOSING THEIR MIND", "DRINKING WATER", "GOING TO GYM"], correct: 1, msg: "CRASHOUT BEHAVIOR DETECTED." },
    { question: "WHAT IS THE PURPOSE OF 'MEWING' IN 2025?", options: ["TALKING TO CATS", "SHARPENING JAWLINE", "IMPROVING MEMORY", "CODING FASTER"], correct: 1, msg: "BYE BYE. (🤫🧏‍♂️)" },
    { question: "IF A FIT IS 'TWEAKED OUT', IT MEANS...", options: ["IT'S PERFECT", "IT'S WEIRD/MESSY", "IT'S EXPENSIVE", "IT'S VINTAGE"], correct: 1, msg: "TWEAKED TO THE MAX." },
    { question: "WHAT DOES 'SKIBIDI' MEAN IN 2025 CONTEXT?", options: ["TOILET HUMOR", "GENERAL ADJECTIVE", "A DANCE STEP", "NOTHING AT ALL"], correct: 3, msg: "IT'S LITERALLY GIBBERISH NOW." },
    { question: "A 'SIGMA' IN 2025 IS GENERALLY CONSIDERED...", options: ["A LEADER", "CRINGE/SATIRE", "A CRYPTO COIN", "A GREEK LETTER"], correct: 1, msg: "POST-IRONIC SIGMA." },
    { question: "IF YOU ARE 'COOKED', YOUR SITUATION IS...", options: ["GREAT", "BEYOND REPAIR", "HEATING UP", "DELICIOUS"], correct: 1, msg: "ABSOLUTELY FRIED." },
    { question: "WHAT IS 'BRAINROT' ACTUALLY?", options: ["MEDICAL CONDITION", "GEN ALPHA CONTENT", "A NEW FRUIT", "A VIDEO GAME"], correct: 1, msg: "SUBWAY SURFERS INTENSIFIES." },
    { question: "WHAT DOES 'RIZZ' STAND FOR ORIGINALLY?", options: ["CHARISMA", "RIZZLER", "RIZOTTO", "RIGHTEOUS"], correct: 0, msg: "OXFORD DICTIONARY APPROVED." },
    { question: "IF SOMEONE SAYS 'DEMURE', THEY ARE...", options: ["ANGRY", "MINDFUL/MODEST", "LOUD", "RICH"], correct: 1, msg: "VERY MINDFUL. VERY PRECISION." }
  ];
  const [score, setScore] = useState(0);
  const [step, setStep] = useState(0);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const manualRef = useRef(null);

  // 🌟 Function to handle the smooth scroll
  const scrollToManual = () => {
    manualRef.current?.scrollIntoView({ behavior: 'smooth',block: 'center' });
  };
  const handleCheckAnswer = (index) => {
    if (showFeedback) return;

    setSelectedIdx(index);
    setShowFeedback(true);

    if (index === QUIZ_DATA[step].correct) {
      setScore(prev => prev + 1);
    }

    setTimeout(() => {
      if (step < QUIZ_DATA.length - 1) {
        setStep(step + 1);
        setSelectedIdx(null);
        setShowFeedback(false);
      } else {
        setIsFinished(true);
      }
    }, 1200);
  };
  const getLoreVerdict = () => {
    if (score === 10) return "ULTIMATE SIGMA: YOUR BRAIN IS COMPLETELY GONE.";
    if (score >= 7) return "RIZZ MASTER: YOU ARE READY FOR 2026.";
    if (score >= 4) return "BETWEEN LORE: NEITHER SIGMA NOR NORMIE.";
    return "TOTAL NORMIE: GO BACK TO FACEBOOK.";
  };

  const navigate = useNavigate();
  const { user } = useAuth();
  const { scrollYProgress } = useScroll();
  const [loadingStep, setLoadingStep] = useState('loader');
  const bgColor = useTransform(scrollYProgress, [0, 0.2, 0.5, 0.8, 1], ["#FFFFFF", "#CFFF04", "#050505", "#FF007A", "#FFFFFF"]);
  const handleLockIn = () => {
    if (user) { navigate(`/dashboard/${user.uid}`); } else { navigate('/signup'); }
  };
  // Add these transforms inside your LandingPage component
const rotateX = useTransform(scrollYProgress, [0, 1], [0, 10]); // Tilts the page back
const skewY = useTransform(scrollYProgress, [0, 0.5, 1], [0, -2, 0]); // Adds organic "bend"
  return (
    
    <motion.div className="landing-wrapper" style={{ backgroundColor: bgColor, rotateX, skewY}}>
      <AnimatePresence mode="wait">
        {loadingStep === 'loader' && (<CreativeLoader key="loader" onComplete={() => setLoadingStep('flash')} />)}
      </AnimatePresence>
      <section className="section-full hero-flex">
        <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} className="hero-content">
          <h1 className="massive-title">R e v i s i t <span className="the"> the</span><br /><span className="font-highlight">big 2025</span><br />
            <span className="logo-rewind">O N E S T O P</span>
            <span className="logo-dot">.</span>
            <span className="logo-25">2 5</span> </h1>
          <div className="hero-btns">
            <button className="btn-solid" onClick={handleLockIn}>LOCK IN</button>
            <button className="btn-outline" onClick={scrollToManual}>LEARN MORE</button>
          </div>
        </motion.div>
        <motion.div animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }} transition={{ duration: 4, repeat: Infinity }} className="floating-orb" />
      </section>

      <div ref={manualRef} className="marquee-container">
        <MarqueeItem baseVelocity={-2}>
          i will be non chalant || focus on goals || 10000 aura points || i will stop doomscrolling || stop being chopped || i will grow 6'7 || 2026 literally my year || i will get j*b🥀 || unemployment is not my thing ||
        </MarqueeItem>
      </div>
      {/* 🌟 NEW: APP MANUAL SECTION (Below Marquee) */}
      <section className="app-manual-section">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="manual-grid"
        >
          <div className="manual-item card-rewind">
            <span className="manual-number">01</span>
            <h3>MY AURA</h3>
            <p>our ai generates aura moments you might have possibly encountered. try it yourself and see the magic</p>
          </div>
          
          <div className="manual-item card-manifest">
            <span className="manual-number">02</span>
            <h3>2026 VISION Board</h3>
            <p>manifest your 2026 with our ai. make 2026 your year. stay locked in.</p>
          </div>

          <div className="manual-item card-bucket">
            <span className="manual-number">03</span>
            <h3>THE BUCKETLIST</h3>
            <p>personal goals or group chaos list your 2026 dreams with your people.</p>
          </div>

          <div className="manual-item card-inout">
            <span className="manual-number">04</span>
            <h3>IN / OUT</h3>
            <p>clearly write down what's in and what's out from 2025. smart people don't take shi too long.</p>
          </div>
        </motion.div>
      </section>
      <section className="meme-marathon">
        <div className="marathon-header">
          <motion.h2
            initial={{ x: -100, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            className="marathon-title"
          >
            MEME <span>MARATHON</span>
          </motion.h2>
          <p style={{
  color: '#FF8C00', // Vibrant Deep Orange
  fontFamily: '"Fredoka", "Inter", system-ui, sans-serif',
  fontSize: '1.2rem',
  fontWeight: '800',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  textShadow: '2px 2px 0px rgba(0,0,0,0.1)', // Subtle "sticker" depth
  margin: '10px 0',
  display: 'inline-block',
  background: 'rgba(255, 140, 0, 0.1)', // Soft orange glow background
  padding: '4px 12px',
  borderRadius: '8px',
  border: '1.5px dashed #FF8C00' // Marker/Crayony outline
}}>
  2025 Meme Wrapped js for you twn
</p>
        </div>

        <motion.div
          className="carousel-container"
          drag="x"
           dragConstraints={{ right: 0, left: -5400}}
        >
          {memes.map((meme) => (
            <motion.div
              key={meme.id}
              className="meme-card"
              whileHover={{ scale: 1.05, rotate: 2 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="meme-img-wrapper">
                <img src={meme.url} alt="meme" draggable="false" />
              </div>
              
            </motion.div>
          ))}
        </motion.div>
      </section>
      <section className="quiz-section">
        <div className="quiz-container">
          <AnimatePresence mode="wait">
            {!isFinished ? (
              <motion.div
                key={step}
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                className="quiz-card"
              >
                <div className="quiz-top-info">
                  <div className="mini-progress">
                    <motion.div className="bar" animate={{ width: `${((step + 1) / 10) * 100}%` }} />
                  </div>
                  <span className="score-badge">{score} PTS</span>
                </div>

                <h2 className="quiz-q-text">{QUIZ_DATA[step].question}</h2>

                <div className="quiz-options-list">
                  {QUIZ_DATA[step].options.map((opt, idx) => {
                    let stateClass = "";
                    if (showFeedback) {
                      if (idx === QUIZ_DATA[step].correct) stateClass = "is-correct";
                      else if (idx === selectedIdx) stateClass = "is-wrong";
                    }

                    return (
                      <button
                        key={idx}
                        onClick={() => handleCheckAnswer(idx)}
                        className={`quiz-btn-new ${stateClass}`}
                      >
                        {opt}
                      </button>
                    );
                  })}
                </div>

                {showFeedback && (
                  <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="quiz-msg-pop">
                    {selectedIdx === QUIZ_DATA[step].correct ? QUIZ_DATA[step].msg : "L + RATIO + WRONG"}
                  </motion.div>
                )}
              </motion.div>
            ) : (
              <motion.div initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="quiz-final-wrap">
                <h1 className="final-score">{score}<span>/10</span></h1>
                <p className="verdict-text">{getLoreVerdict()}</p>
                <button className="reset-btn" onClick={() => window.location.reload()}>RE-INITIALIZE</button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        
      </section>
    </motion.div>
  );
}
